/* eslint-disable eqeqeq */
/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import PagesContainer from "src/components/shared/molecules/PagesContainer";
import USER_PENDING_CHATS_DATA from "src/graphql/query/dashboard/PendingTable/userPendingChatsData";
import PENDING_CHAT_COUNT_CHANGED_SUBSCRIPTION from "src/graphql/subscriptions/dashboard/pendingchatcount";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useLazyQuery, useSubscription } from "@apollo/client";
import PendingSkeleton from "src/components/pages/dashboard/skeleton/dashboard/PendingTable";
import { UseDashboardContext } from "src/context/dashboard";
import { useSelector } from "react-redux";
import useAuth from "src/hooks/useAuth";

import { useSnackbar as Snackbar } from "notistack";
import Badge, { BadgeProps } from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import useStyles from "./Styles";

interface IProps {
  title?: string;
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -12,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const ListContainer: React.FC<IProps> = ({ title }: { title?: string }) => {
  const { me }: any = useSelector((state: any) => state.me);
  useAuth();
  const { classes } = useStyles();
  const { enqueueSnackbar } = Snackbar();

  const { agentId, mainSuperAdminId } = useActiveUserDetail();

  const [pendingCount, setPendingCount] = useState(0);
  const [pendingPages, setPendingPages] = useState([]);
  const contextData = UseDashboardContext();
  let storedAgentId: any;

  if (contextData) {
    ({ storedAgentId } = contextData);
  }

  // pendingsubscriptiondata
  const {
    data: pendingChatCountChangedSubscriptionResult,
    error: pendingChatCountChangedSubscriptionError,
  } = useSubscription(PENDING_CHAT_COUNT_CHANGED_SUBSCRIPTION);

  useEffect(() => {
    if (pendingChatCountChangedSubscriptionError) {
      enqueueSnackbar(pendingChatCountChangedSubscriptionError.message, {
        variant: "error",
      });
    }
  }, [pendingChatCountChangedSubscriptionError]);

  useEffect(() => {
    if (pendingChatCountChangedSubscriptionResult?.pendingchatcountchanged) {
      const result = JSON.parse(
        pendingChatCountChangedSubscriptionResult.pendingchatcountchanged
          .result,
      );
      if (
        result.mainSuperAdminId == mainSuperAdminId &&
        storedAgentId == agentId
      ) {
        const mePages = me?.pages ? JSON.parse(me.pages) : [];

        const filteredData = result.pendingData.filter(
          (item: {
            count: number;
            name: string;
            pageId: string;
            picture: string;
          }) => mePages.includes(item.pageId),
        );
        const filteredCounts = filteredData.reduce(
          (total: number, item: { count: number }) => total + item.count,
          0,
        );

        setPendingCount(filteredCounts);
        setPendingPages(filteredData);
      }
    }
  }, [pendingChatCountChangedSubscriptionResult]);

  const [
    getUserPendingChat,
    { data: chatCountResult, loading: chatCountLoading },
  ] = useLazyQuery(USER_PENDING_CHATS_DATA, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (storedAgentId !== 0) {
      getUserPendingChat({
        variables: {
          agentId: storedAgentId,
        },
      });
    }
  }, [storedAgentId]);

  useEffect(() => {
    if (chatCountResult && chatCountResult.userPendingChatsData) {
      if (chatCountResult.userPendingChatsData.success) {
        const pendingData = JSON.parse(
          chatCountResult.userPendingChatsData.result,
        );
        const totalCount = pendingData.reduce(
          (total: number, item: { count: number }) => total + item.count,
          0,
        );
        setPendingCount(totalCount);
        setPendingPages(pendingData);
      }
    }
  }, [chatCountResult]);

  return chatCountLoading ? (
    <PendingSkeleton />
  ) : (
    <Box className={classes.gridItems}>
      <Box className={classes.flex}>
        <StyledBadge color="primary" badgeContent={pendingCount}>
          <Typography className={classes.headerText}>{title}</Typography>
        </StyledBadge>
      </Box>

      <Box className={classes.pagesContainer}>
        <PagesContainer
          title={title}
          dataList={pendingPages}
          chatTitle="pending"
        />
      </Box>
    </Box>
  );
};

export default ListContainer;
